import { Providers } from './providers';
import { AppRoutes } from './routes';

export function App() {
  return (
    <Providers>
      <AppRoutes />
    </Providers>
  );
}
